type Props = {
  color?: string;
};

export default function SelectedProfile({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0612 12.7286C16.1105 11.532 17.5 9.36 17.5 6.85714C17.5 3.07543 14.3605 0 10.5 0C6.6395 0 3.5 3.07543 3.5 6.85714C3.5 9.36 4.8895 11.532 6.93875 12.7286C2.98025 14.352 0 18.5211 0 23.1429C0 23.616 0.392 24 0.875 24H20.125C20.608 24 21 23.616 21 23.1429C21 18.5211 18.0198 14.352 14.0612 12.7286Z"
        fill={color}
      />
    </svg>
  );
}
